import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { picFilter } from '@/assets/utils';
import { getMaterialPurchaseDetail, getSecondaryProcessDetail, getByGroupIdentification } from '@/api/MES/produceManagement';
export default {
  name: 'V',
  components: {},
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      activeNames: ['1', '2', '3'],
      visible: false,
      text: this.rowData[this.fieldData.fieldCode] === '1' ? '面料采购信息' : '二次工艺采购信息',
      type: this.rowData[this.fieldData.fieldCode],
      // 1面料采购信息,2二次工艺采购信息
      purInfo: {
        purchaseQty: 0,
        // 采购米数
        estimateQty: 0,
        // 预估数量
        orderQty: 0,
        // 订单数量
        differenceQty: 0 // 差异件数
      },

      fileList: [],
      params: {
        "id": "",
        // 主键id
        "image": "",
        // 商品主图
        "materialName": "",
        // 物料名称
        "materialImage": "",
        // 物料图片
        "orderCode": "",
        // 订单编号
        "stallName": "",
        // 档口名称
        "stallPhone": "",
        // 档口电话
        "supplierColor": "",
        // 供应商色号
        "supplierSpu": "",
        // 供应商货号
        "secondaryProcessName": "",
        // 物料名称
        "materialCode": "",
        // 编码
        "temporaryFabricCoding": "" // 物料项目
      },

      materialPurchaseOrderDetail: {
        "changeSupplierReason": "",
        "materialPurchaseId": "",
        "suggestSupplierCode": "",
        "suggestSupplierName": "",
        "suggestSupplierTel": ""
      },
      unitName: "" // 单位名称
    };
  },

  computed: {
    fileListData: function fileListData() {
      return this.fileList && this.fileList.length > 0 ? this.fileList.map(function (ele) {
        ele.url = picFilter(ele.url, {
          size: 'large'
        });
        return ele;
      }) : [];
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    /** 打开上传凭证对话框 */getCredentialInfo: function () {
      var _getCredentialInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var _this = this;
        var unitData, result, params, purInfo, materialPurchaseOrderDetail;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getByGroupIdentification('Unit');
            case 2:
              unitData = _context.sent.data;
              result = {};
              if (!(this.rowData[this.fieldData.fieldCode] === '1')) {
                _context.next = 10;
                break;
              }
              _context.next = 7;
              return getMaterialPurchaseDetail(id);
            case 7:
              result = _context.sent;
              _context.next = 13;
              break;
            case 10:
              _context.next = 12;
              return getSecondaryProcessDetail(id);
            case 12:
              result = _context.sent;
            case 13:
              if (result.code === 200) {
                this.unitData = unitData;
                // 单位名称
                unitData.map(function (e) {
                  if (e.value === result.data.purchaseUnit) {
                    _this.unitName = e.name;
                  }
                });
                params = _objectSpread(_objectSpread({}, this.params), {}, {
                  "id": result.data.id,
                  // 主键id
                  "image": picFilter(result.data.image, {
                    size: 'large'
                  }),
                  // 商品主图
                  "materialName": result.data.materialName,
                  // 物料名称
                  "materialImage": picFilter(result.data.materialImage, {
                    size: 'large'
                  }),
                  // 物料图片
                  "orderCode": result.data.orderCode,
                  // 编码
                  "stallName": result.data.stallName,
                  // 档口名称
                  "stallPhone": result.data.stallPhone,
                  // 档口电话
                  "supplierColor": result.data.supplierColor,
                  // 供应商色号
                  "supplierSpu": result.data.supplierSpu,
                  // 供应商货号
                  "secondaryProcessName": result.data.secondaryProcessName,
                  // 物料名称
                  "materialCode": result.data.materialCode,
                  // 编码
                  "temporaryFabricCoding": result.data.temporaryFabricCoding // 物料项目
                });
                purInfo = {
                  purchaseQty: result.data.purchaseQty,
                  // 采购米数
                  estimateQty: result.data.estimateQty,
                  // 预估数量
                  orderQty: result.data.orderQty,
                  // 订单数量
                  differenceQty: result.data.differenceQty // 差异件数
                };
                materialPurchaseOrderDetail = _objectSpread(_objectSpread({}, this.materialPurchaseOrderDetail), {}, {
                  "changeSupplierReason": result.data.changeSupplierReason,
                  // 变更档口原因
                  "suggestSupplierName": this.type === '1' ? result.data.stallName : result.data.actualStallName,
                  // 推荐档口名称
                  "suggestSupplierTel": this.type === '1' ? result.data.stallPhone : result.data.actualStallPhone // 推荐联系电话
                });

                this.params = params;
                this.purInfo = purInfo;
                this.materialPurchaseOrderDetail = materialPurchaseOrderDetail;
                this.fileList = result.data.commonAttachmentVos;
                this.visible = true;
              } else {
                this.resetAllData();
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCredentialInfo(_x) {
        return _getCredentialInfo.apply(this, arguments);
      }
      return getCredentialInfo;
    }(),
    resetAllData: function resetAllData() {
      this.visible = false;
    }
  }
};